var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.81,38.99c-9.85,0-17.83,7.99-17.83,17.84s7.98,17.84,17.83,17.84,17.84-7.99,17.84-17.84",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.65,56.83h10.27v6.22l-4.44.57c-.5,1.8-1.21,3.51-2.1,5.11l2.72,3.56-8.81,8.81-3.56-2.72c-1.6.88-3.31,1.6-5.11,2.11l-.57,4.43h-12.47l-.57-4.43c-1.8-.51-3.51-1.23-5.11-2.11l-3.53,2.72-8.82-8.81,2.71-3.54c-.88-1.61-1.6-3.33-2.11-5.13l-4.42-.57v-12.46l4.43-.57c.5-1.8,1.22-3.51,2.1-5.11l-2.71-3.54,8.82-8.81,3.53,2.71c1.6-.88,3.31-1.6,5.11-2.11l.57-4.43h6.23v10.26",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.81,
    y1: 46.78,
    x2: 56.81,
    y2: 67.44,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.14,
    y1: 57.11,
    x2: 46.48,
    y2: 57.11,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.e094bfa316df523ad8934248001cb118.svg";
export { ForwardRef as ReactComponent };